import React from "react";
import { List } from "../modules/Sites";

export function SitesListPage() {
  return <List />;
}
